var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announcement-bar"},[_c('div',{staticClass:"announcement-text",style:({ transform: `translateX(${_vm.translateX}%)` })},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"announcement-item"},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }